'use client';

import { API_DATE_FORMAT } from '@epos/utilities';
import { DatePicker as MuiDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/en-sg';
import { useCallback } from 'react';

import { CalendarIcon } from '../../assets';
import { BaseFieldProps } from '../../base';

const DatePicker: React.FC<BaseFieldProps> = ({
  value,
  onChange = () => {},
  error,
  helperText,
  required,
  size,
  ...props
}) => {
  const dateChangedHandler = useCallback((newValue: Dayjs | string | null) => {
    onChange((newValue as Dayjs)?.format(API_DATE_FORMAT) || '');
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en-sg'>
      <MuiDatePicker
        {...props}
        slots={{
          openPickerIcon: CalendarIcon
        }}
        defaultValue={value ? dayjs(value, API_DATE_FORMAT) : undefined}
        onChange={dateChangedHandler}
        slotProps={{
          ...props.slotProps,
          openPickerButton: {
            ...props.slotProps?.openPickerButton,
            size: 'small'
          },
          textField: {
            ...props.slotProps?.textField,
            inputProps: {
              readOnly: true
            },
            error: Boolean(error),
            size,
            helperText,
            required
          }
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
